import React from 'react';
import { useTranslation } from 'react-i18next';
import { GrievanceItem } from '../../services/types/Grievance';
import GeneralInfoItem from '../Operations/Operation/GeneralInfoItem';
import AvatarGroup from '../Operations/Operation/AvatarGroup';
import { getInitials } from '../../shared/misc/utils';

export interface TeamMember {
  imgPath?: string;
  name: string;
  initials: string;
}

interface Props {
  grievance: GrievanceItem;
}
const GIOperationInfo: React.FC<Props> = ({ grievance }) => {
  const { t } = useTranslation();

  const memberList = grievance.operationMembers.split(', ').map((item) => item.trim());
  const members = memberList
    ? memberList.map((userMember) => ({
        name: userMember,
        initials: getInitials(userMember),
      }))
    : null;

  return (
    <div className="gi-items table-responsive">
      <GeneralInfoItem title={t('regionCountry')}>
        {grievance.region}
        {!!grievance.region && !!grievance.operationCountry ? ' / ' : ''}
        {grievance.operationCountry}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('sectorSubSector')}>
        {grievance.operationSector}
        {!!grievance.operationSector && !!grievance.operationSubSector ? ' / ' : ''}
        {grievance.operationSubSector}
      </GeneralInfoItem>
      <GeneralInfoItem title={t('teamLeader')}>{grievance.operationTeamLeader}</GeneralInfoItem>
      <GeneralInfoItem title={t('executingAgency')}>
        <div id="executingAgenciesValue">{grievance.executingAgency}</div>
      </GeneralInfoItem>

      <GeneralInfoItem title={t('primaryMember')}>
        {grievance.operationPrimaryMember}
      </GeneralInfoItem>

      <GeneralInfoItem title={t('teamMembers')} classContent="avatar" minWidth={200}>
        {members && grievance.operationMembers && <AvatarGroup members={members} />}
      </GeneralInfoItem>
    </div>
  );
};

export default GIOperationInfo;
